import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-index',
  templateUrl: './manual-index.component.html',
  styleUrls: ['./manual-index.component.css'],
  standalone: false,
})
export class ManualIndexComponent implements OnInit {

  // トップ画面
  readonly topLink = AppConst.ROUTING_LINK_MANUAL_TOP;
  readonly topDialogLink = AppConst.ROUTING_LINK_MANUAL_TOP_DIALOG;
  // プロジェクト情報
  readonly projectLink = AppConst.ROUTING_LINK_MANUAL_PROJECT;
  readonly projectDialogLink = AppConst.ROUTING_LINK_MANUAL_PROJECT_DIALOG;
  // SPLATS情報
  readonly splatsLink = AppConst.ROUTING_LINK_MANUAL_SPLATS;
  // ユーザー情報
  readonly userLink = AppConst.ROUTING_LINK_MANUAL_USER;
  readonly userDialogLink = AppConst.ROUTING_LINK_MANUAL_USER_DIALOG;
  // ファイルアップロード画面
  readonly uploaderLink = AppConst.ROUTING_LINK_MANUAL_UPLOADER;
  // ファイルアップロード画面（プレゼント用）
  readonly uploaderDLLink = AppConst.ROUTING_LINK_MANUAL_UPLOADER_DL;
  // 施設情報
  readonly facilityLink = AppConst.ROUTING_LINK_MANUAL_FACILITY;
  readonly facilityDialogLink = AppConst.ROUTING_LINK_MANUAL_FACILITY_DIALOG;
  // 建物情報
  readonly hallLink = AppConst.ROUTING_LINK_MANUAL_HALL;
  readonly hallDialogLink = AppConst.ROUTING_LINK_MANUAL_HALL_DIALOG;
  // フロア情報
  readonly floorLink = AppConst.ROUTING_LINK_MANUAL_FLOOR;
  readonly floorDialogLink = AppConst.ROUTING_LINK_MANUAL_FLOOR_DIALOG;
  // 展示情報
  readonly exhibitLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT;
  readonly exhibitDialogLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_DIALOG;
  readonly exhibitDetailLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_DETAIL;
  readonly exhibitDetailDialogLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_DETAIL_DIALOG;
  readonly exhibitRankingLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_RANKING;
  readonly voiceFileDownloadLink = AppConst.ROUTING_LINK_MANUAL_VOICE_FILE_DOWNLOAD;
  // 施設属性情報
  readonly facilityAttributeLink = AppConst.ROUTING_LINK_MANUAL_FACILITY_ATTRIBUTE;
  readonly facilityAttributeDialogLink = AppConst.ROUTING_LINK_MANUAL_FACILITY_ATTRIBUTE_DIALOG;
  // 展示属性情報
  readonly exhibitAttributeLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_ATTRIBUTE;
  readonly exhibitAttributeDialogLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_ATTRIBUTE_DIALOG;
  // 展示詳細属性情報
  readonly exhibitDetailAttributeLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE;
  readonly exhibitDetailAttributeDialogLink = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE_DIALOG;
  // 予約施設属性情報
  readonly reservationFacilityAttributeLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_FACILITY_ATTRIBUTE;
  readonly reservationFacilityAttributeDialogLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_FACILITY_ATTRIBUTE_DIALOG;
  // 通知情報
  readonly noticeLink = AppConst.ROUTING_LINK_MANUAL_NOTICE;
  // 本番反映
  readonly reflectDataLink = AppConst.ROUTING_LINK_MANUAL_REFLECT_DATA;
  // アプリ表示名ダイアログ
  readonly appnameDialogLink = AppConst.ROUTING_LINK_MANUAL_APPNAME_DIALOG;
  // 名称ダイアログ
  readonly nameDialogLink = AppConst.ROUTING_LINK_MANUAL_NAME_DIALOG;
  // 詳細ダイアログ
  readonly descDialogLink = AppConst.ROUTING_LINK_MANUAL_DESC_DIALOG;
  // 住所ダイアログ
  readonly addressDialogLink = AppConst.ROUTING_LINK_MANUAL_ADDRESS_DIALOG;
  // コピーライトダイアログ
  readonly copyrightDialogLink = AppConst.ROUTING_LINK_MANUAL_COPYRIGHT_DIALOG;
  // プライバシーポリシーダイアログ
  readonly policyDialogLink = AppConst.ROUTING_LINK_MANUAL_POLICY_DIALOG;
  // FAQダイアログ
  readonly faqDialogLink = AppConst.ROUTING_LINK_MANUAL_FAQ_DIALOG;
  // YouTube埋め込みコード編集ダイアログ
  readonly youtubeDialogLink = AppConst.ROUTING_LINK_MANUAL_YOUTUBE_DIALOG;
  // 外部リンクURLダイアログ
  readonly urlDialogLink = AppConst.ROUTING_LINK_MANUAL_URL_DIALOG;
  // ユーザー入力タイトルダイアログ
  readonly userInputTitleDialogLink = AppConst.ROUTING_LINK_MANUAL_USER_INPUT_TITLE_DIALOG;
  // メール送信タイトルダイアログ
  readonly sendMailTitleDialogLink = AppConst.ROUTING_LINK_MANUAL_SEND_MAIL_TITLE_DIALOG;
  // メール送信本文ダイアログ
  readonly sendMailMessageDialogLink = AppConst.ROUTING_LINK_MANUAL_SEND_MAIL_MESSAGE_DIALOG;
  // QR(URL)生成ページ選択
  readonly qrcodeLink = AppConst.ROUTING_LINK_MANUAL_QRCODE;
  // QRコード生成結果
  readonly qrcodeResultLink = AppConst.ROUTING_LINK_MANUAL_QRCODE_RESULT;
  // URL生成結果
  readonly urlResultLink = AppConst.ROUTING_LINK_MANUAL_URL_RESULT;
  // 設問情報
  readonly questionLink = AppConst.ROUTING_LINK_MANUAL_QUESTION;
  readonly questionDialogLink = AppConst.ROUTING_LINK_MANUAL_QUESTION_DIALOG;
  readonly questionSortDialogLink = AppConst.ROUTING_LINK_MANUAL_QUESTION_SORT_DIALOG;
  // 設問セット
  readonly questSetLink = AppConst.ROUTING_LINK_MANUAL_QUEST_SET;
  readonly questSetDialogLink = AppConst.ROUTING_LINK_MANUAL_QUEST_SET_DIALOG;
  // 予約設備
  readonly reservationFacilityLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_FACILITY;
  readonly reservationFacilityDialogLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_FACILITY_DIALOG;
  // 設備予約状況：閲覧
  readonly reservationFacilityReservationLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_FACILITY_RESERVATION;
  // 予約設備：特別営業日
  readonly reservationFacilitySpecialLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_FACILITY_SPECIAL;
  readonly reservationFacilitySpecialDialogLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_FACILITY_SPECIAL_DIALOG;
  // 予約設問
  readonly reservationQuestionLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_QUESTION;
  readonly reservationQuestionDialogLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_QUESTION_DIALOG;
  // 予約状況
  readonly reservationLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION;
  readonly reservationDialogLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_DIALOG;
  readonly selectReservationDialogLink = AppConst.ROUTING_LINK_MANUAL_SELECT_RESERVATION_DIALOG;
  readonly confirmReservationDialogLink = AppConst.ROUTING_LINK_MANUAL_CONFIRM_RESERVATION_DIALOG;
  readonly confirmReservationDetailDialogLink = AppConst.ROUTING_LINK_MANUAL_CONFIRM_RESERVATION_DETAIL_DIALOG;
  // 予約ダウンロード
  readonly reservationDownloadLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_DOWNLOAD;
  // 予約ダウンロードファイル作成ダイアログ
  readonly reservationDownloadDialogLink = AppConst.ROUTING_LINK_MANUAL_RESERVATION_DOWNLOAD_DIALOG;
  // 避難所情報
  readonly shelterLink = AppConst.ROUTING_LINK_MANUAL_SHELTER;
  readonly shelterDialogLink = AppConst.ROUTING_LINK_MANUAL_SHELTER_DIALOG;
  // アンケート結果ダウンロード
  readonly enqueteLink = AppConst.ROUTING_LINK_MANUAL_ENQUETE;
  // アンケート結果ダウンロードファイル作成ダイアログ
  readonly enqueteDialogLink = AppConst.ROUTING_LINK_MANUAL_ENQUETE_DIALOG;
  // 掲示板
  readonly boardThreadLink = AppConst.ROUTING_LINK_MANUAL_BOARD_THREAD;
  readonly boardThreadDialogLink = AppConst.ROUTING_LINK_MANUAL_BOARD_THREAD_DIALOG;
  readonly boardCommentLink = AppConst.ROUTING_LINK_MANUAL_BOARD_COMMENT;
  readonly boardCommentDialogLink = AppConst.ROUTING_LINK_MANUAL_BOARD_COMMENT_DIALOG;
  // 施設職員情報
  readonly facilityUserLink = AppConst.ROUTING_LINK_MANUAL_FACILITY_USER;
  readonly facilityUserDialogLink = AppConst.ROUTING_LINK_MANUAL_FACILITY_USER_DIALOG;
  // コンテンツ購入日次情報
  readonly purchaseContentDailyLink = AppConst.ROUTING_LINK_MANUAL_PURCHASE_CONTENT_DAILY;
  readonly purchaseContentDailyDialogLink = AppConst.ROUTING_LINK_MANUAL_SELECT_PURCHASE_CONTENT_DAILY_DIALOG;
  // 入退場管理:イベント情報
  readonly entranceExitEventLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_EVENT;
  // 入退場管理:イベント設問情報
  readonly entranceExitQuestionLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_QUESTION;
  readonly entranceExitQuestionDialogLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_QUESTION_DIALOG;
  // 入退場管理:スタッフ情報
  readonly entranceExitUserLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_USER;
  readonly entranceExitUserDialogLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_USER_DIALOG;
  // 入退場管理:エントリー情報
  readonly entranceExitEntryLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_ENTRY;
  readonly selectEntranceExitEntryDialogLink = AppConst.ROUTING_LINK_MANUAL_SELECT_ENTRANCE_EXIT_ENTRY_DIALOG;
  readonly entranceExitEntryDialogLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_ENTRY_DIALOG;
  readonly entranceExitTransitDialogLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_TRANSIT_DIALOG;
  // 入退場管理:日次入退場状況
  readonly entranceExitTransitDailyLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY;
  readonly selectEntranceExitTransitDailyDialogLink = AppConst.ROUTING_LINK_MANUAL_SELECT_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG;
  readonly entranceExitTransitDailyDialogLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG;
  // 入退場管理:展示来場状況ダウンロード
  readonly entranceExitExhibitTransitDownloadLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD;
  readonly entranceExitExhibitTransitDownloadDialogLink = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
